import React from 'react';
import type { ResultadoCarga } from '../../api/feriasApi';
import { FctAviso, FctIcono } from '../../fct/react';
import { listaCasos, MOTIVO_RECHAZO } from './textos';

/**
 * El resultado de una carga, una línea por archivo: el caso creado, con los casos de los que puede ser
 * duplicado, o el motivo del rechazo. Cada línea lleva icono y palabras, nunca solo color.
 */
export function ResultadosCarga({ resultados }: { resultados: ResultadoCarga[] }) {
  const creados = resultados.filter((r) => r.idCaso !== null).length;
  const rechazados = resultados.length - creados;

  return (
    <section aria-label="Resultado de la subida">
      <FctAviso
        tipo={rechazados === 0 ? 'exito' : 'aviso'}
        titulo={`${creados} ${creados === 1 ? 'caso creado' : 'casos creados'}, ${rechazados} ${
          rechazados === 1 ? 'archivo rechazado' : 'archivos rechazados'
        }`}
      >
        Los archivos rechazados no se han guardado.
      </FctAviso>
      <ul className="ferias-lista-resultados">
        {resultados.map((resultado, indice) => (
          <li key={`${indice}-${resultado.nombreArchivo}`}>
            {resultado.idCaso !== null ? (
              <>
                <FctIcono nombre="completado" /> <span className="fct-mono">{resultado.nombreArchivo}</span>: caso #
                {resultado.idCaso} creado.
                {resultado.duplicadoDe.length > 0 && <> Posible duplicado de {listaCasos(resultado.duplicadoDe)}.</>}
              </>
            ) : (
              <>
                <FctIcono nombre="alerta" /> <span className="fct-mono">{resultado.nombreArchivo}</span>: rechazado.{' '}
                {MOTIVO_RECHAZO[resultado.rechazo ?? 'error-almacenamiento']}
              </>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
